export default {
  login: 'Iniciar sesión',
  loginAccountType: 'Inicia sesión con tu cuenta de {type}',
  loginAccount: '¿Ya tienes una cuenta?',
  restaurant: 'Restaurante',
  provider: 'Proveedor',
  isRestaurant: 'Soy restaurante',
  isProvider: 'Soy proveedor',
  forgotPassword: '¿Olvidaste tu contraseña?',
  noAccount: '¿Aún no tienes cuenta en Eato?',
  recoveryPassword: 'Recuperar contraseña',
  createPassword: 'Crea una contraseña para tu cuenta',
  resetPassword: 'Cambia tu contraseña',
  createAccount: 'Crear cuenta de eato',
  createAccountType: 'Datos personales de la cuenta del {type}',
  selectRestaurant: 'Selecciona un restaurant',
  linkExpired: 'El link para recuperar contraseña ya expiró',
  welcome: '¡Bienvenido a eato.mx!',
  thanks: '¡Gracias por registrarte en eato.mx!',
  verify: 'Te enviamos un correo para que puedas entrar, consulta tu mail:',
  accept: 'Aceptar',
  newProvider: 'Nuevo proveedor',
  createProvider: 'Crear proveedor',
  newRestaurant: 'Nuevo restaurante',
  createRestaurant: 'Crear restaurante',
  labels: {
    acceptInvitation: 'Aceptar invitación',
    email: 'Correo electrónico',
    password: 'Contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirma tu contraseña',
    signIn: 'Entrar a eato',
    forgotPassword: 'Recupérala aquí',
    register: 'Regístrate aquí',
    sendMail: 'Enviar correo',
    firstName: 'Nombres del usuario',
    lastName: 'Apellidos del usuario',
    phone: 'Teléfono',
    signUp: 'Crear cuenta',
    logOut: 'Cerrar Sesión',
    createProvider: 'Crea un proveedor para empezar',
    createRestaurant: 'Crea un restaurante para empezar'
  }
}
